import { useEffect, useState } from 'react'

const useScrollYPosition = () => {
  const [position, setPosition] = useState(0)

  function onScroll() {
    setPosition(window.scrollY)
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return {
    scrollHeight: position,
  }
}
export default useScrollYPosition
